/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamIntegrityBudget } from './oralExamIntegrityBudget';

export type OralExamRunStateResponseIntegrityBudget = OralExamIntegrityBudget | null;
